import { useMemo } from 'react';
import { CommonHeadingTxt } from '../Text/Text';
import AdvancedTable from '../AdvancedTable';

const DoctorLeaveList = ({ leaves }) => {
  // Memoize columns
  const columns = useMemo(
    () => [
      {
        name: 'Doctor Name',
        selector: 'adminName',
        key: 'adminName',
        width: 180,
        render: (text, record) => {
          if (record.adminType === 'Doctor') {
            return text;
          }
          return null;
        },
        filterable: true,
      },
      {
        name: 'Leave Type',
        selector: 'leaveType',
        width: 150,
        render: (text) => text || '---',
        filterable: true,
        key: 'leaveType',
      },
      {
        name: 'Status',
        selector: 'status',
        key: 'status',
        width: 120,
        render: (text) => {
          if (!text) return '---';
          const statusColors = {
            'Approved': 'success',
            'Pending': 'warning',
            'Rejected': 'danger',
          };
          const colorClass = statusColors[text] || 'secondary';
          return `<span class="badge badge-${colorClass}">${text}</span>`;
        },
        filterable: true,
      },
      {
        name: 'Leave From',
        selector: row => row.fromDate,
        key: 'fromDate',
        width: 150,
        filterable: true,
      },
      {
        name: 'Leave To',
        key: 'toDate',
        width: 150,
        selector: row => row.toDate,
        filterable: true,
      },
      {
        name: 'Total Days',
        selector: 'noOfDays',
        key: 'noOfDays',
        width: 120,
        render: (text, record) => {
          if (record.isHalfDay) {
            return `${text} (Half Day)`;
          }
          return text;
        },
        filterable: true,
      },
      {
        name: 'Reason',
        selector: 'reason',
        key: 'reason',
        width: 200,
        render: (text) => text || '---',
        filterable: true,
      },
    ],
    []
  );

  // Fetch data function
  const fetchDoctorLeaves = useMemo(() => {
    return async ({ page, perPage }) => {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      const data = leaves || [];
      return {
        data: data.slice(start, end),
        total: data.length,
      };
    };
  }, [leaves]);

  return (
    <div className="card mb-4 mt-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <CommonHeadingTxt Text="Doctor Leave Overview" />
        </div>
        <AdvancedTable
          key="doctor-leaves-table"
          resource="doctor-leaves"
          columns={columns}
          fetchData={fetchDoctorLeaves}
          enableSearch={false}
          enableFilters={false}
          enableExport={false}
          enableToolBar={false}
          enableSummary={false}
          defaultPageSize={5}
          tableId="doctor-leaves-table"
        />
      </div>
    </div>
  );
};

export default DoctorLeaveList;
